import { DisplayProduct, Product } from '../models';

export const productsParserWithSelectedItem = (
  products?: Product[],
  selectedId?: string,
): DisplayProduct[] =>
  products?.map((product) => ({
    ...product,
    id: product.key,
    url: product.defaultUrl,
    highlight: product.key === selectedId,
  })) || [];
